(function () {
    angular.module('components.validation', [
        'ngMessages'
    ])
        .directive('validator', validator)
        .directive('valMatches', valMatches);

    validator.$inject = ['$timeout', '$templateRequest', '$compile'];
    function validator($timeout, $templateRequest, $compile) {
        var directive = {
            replace: true,
            require: 'ngModel',
            transclude: 'element',
            template: '<label class="validator"></label>',
            restrict: 'A',
            priority: 1,
            link: link
        };
        return directive;
        function link(scope, element, attrs, ngModel, transclude) {
            var input;
            $templateRequest('/angular/components/validation/validator.html', true).then(function (markup) {
                message = angular.element(markup);
                element.addClass('blurred');
                var form = element.closest('form, [ng-form]');
                var formName = form.is('form') ? form.attr('name') : form.attr('ng-form');
                message.attr('ng-messages', formName + '.' + attrs.name + '.$error');
                message.attr('ng-class', '{ validating: ' + formName + '.' + attrs.name + '.$pending }');
                if (attrs.ngMinlength !== undefined) {
                    var minLength = message.find('[ng-message="minlength"]');
                    minLength.html(minLength.html().replace('{{minlength}}', attrs.ngMinlength));
                }
                transclude(scope, function (clone) {
                    if (clone.length) {
                        element.prepend(clone);
                        clone[0].className = '';
                        input = clone.on('blur keyup change', function (event) {
                            ngModel.$setViewValue(input.val());
                        }).on('focus', function () {
                            element.removeClass('blurred');
                        }).on('blur', function () {
                            element.addClass('blurred');
                            if (ngModel.$touched) return;

                            if (scope.$$phase) {
                                scope.$evalAsync(ngModel.$setTouched);
                            } else {
                                scope.$apply(ngModel.$setTouched);
                            }
                        });
                        input.removeAttr('ng-model');
                    }
                });
                element.append(message);
                $compile(message)(scope);
                var blockChange;
                ngModel.$viewChangeListeners.push(function () {
                    blockChange = true;
                })
                scope.$watch(attrs.ngModel, function (value) {
                    if (!blockChange) {
                        input.val(value);
                        if (value === undefined)
                            ngModel.$setPristine(true);
                    }
                    blockChange = false;
                });
                ngModel.$setPristine();
            });
            scope.toggleMessage = function() {
            }
            scope.$on('$destroy', function () {
                if (input)
                    input.off('blur keyup change');
            });
        }
    }

    function valMatches() {
        var directive = {
            require: 'ngModel',
            restrict: 'A',
            scope: {
                other: '=valMatches'
            },
            link: link
        };
        return directive;
        function link(scope, element, attrs, ngModel) {
            ngModel.$validators.matches = function (modelValue) {
                return modelValue === scope.other || modelValue === scope.other.$modelValue;
            };
            scope.$watch('other', function () {
                ngModel.$validate();
            });
        }
    }
})();